// TODO(RBAC, parent #641 #647): admin only
import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getWorkflowTemplateFormOptions } from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'
import {
  GetWorkflowTemplateFormOptionsRequestSchema,
  type GetWorkflowTemplateFormOptionsResponse,
} from '@ebalance/proto/bffuser/v1/workflow_template_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * テンプレート編集画面 (新規 / 編集 / 複製) が使う 3 マスタ (members / tag_pool /
 * approval_processes) を BFF の集約 RPC 1 本で取得する。
 * workflow-template-form-options-bff-aggregation design: 個別の `useListMembers` / `useGetApprovalFlowScreen` /
 * `useListWorkflowTagPool` の代わりに editor (`Edit.tsx`) がこの 1 hook だけを
 * 呼ぶ (= 編集画面を開いた時のみ取得。 一覧画面には常時 fetch を持ち込まない)。
 */
export function useGetWorkflowTemplateFormOptions(): UseQueryResult<
  GetWorkflowTemplateFormOptionsResponse,
  ConnectError
> {
  return useQuery(
    getWorkflowTemplateFormOptions,
    create(GetWorkflowTemplateFormOptionsRequestSchema, {}),
  )
}
